package fr.manyverse.app.domain.usecase

import fr.manyverse.app.domain.model.AlertType
import fr.manyverse.app.domain.model.EventContent
import fr.manyverse.app.domain.model.EventType
import fr.manyverse.app.domain.repository.GameEventRepository

class SendPlayerAlertUseCase(private val gameEventRepository: GameEventRepository) {
    suspend operator fun invoke(
        tableId: String,
        playerId: String,
        gmId: String,
        characterName: String,
        alertType: AlertType,
        message: String? = null
    ): Result<Unit> = gameEventRepository.createEvent(
        tableId = tableId,
        type = EventType.PLAYER_ALERT,
        triggeredBy = playerId,
        targetParticipants = listOf(gmId),
        content = EventContent.PlayerAlert(
            characterName = characterName,
            alertType = alertType,
            message = message
        )
    ).map { }
}
